import type SVGType from 'types/svg.types';

const WalletEuroIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.7416 9.0402H6.58835C5.47867 9.0402 4.5791 8.14062 4.5791 7.03095M15.7416 9.0402H17.5276C18.514 9.0402 19.3136 9.83981 19.3136 10.8262V17.5237C19.3136 18.5101 18.514 19.3097 17.5276 19.3097H12.1696M15.7416 9.0402V5.88843C15.7416 5.16315 15.1536 4.5752 14.4284 4.5752H7.03485C5.67858 4.5752 4.5791 5.67467 4.5791 7.03095M4.5791 11.2727V7.03095"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M4.2998 16.792H6.26179M8.76243 14.68C8.34817 14.1364 7.77502 13.8 7.14178 13.8C5.87817 13.8 4.8538 15.1396 4.8538 16.792C4.8538 18.4444 5.87817 19.784 7.14178 19.784C7.77502 19.784 8.34817 19.4476 8.76243 18.904"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);

export default WalletEuroIcon;
